import React from 'react';

export default function BkashTermsPage() {
  const handleClose = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.close();
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      height: '100vh',
      overflowY: 'auto',
      background: 'var(--bg, #0e1016)',
      color: 'var(--t1, #f0f0f5)',
      fontFamily: "'Inter', 'Outfit', sans-serif",
    }}>
      {/* Header bar */}
      <div style={{
        position: 'sticky', top: 0, zIndex: 10,
        display: 'flex', alignItems: 'center', gap: 12,
        padding: '14px 24px',
        background: 'rgba(14,16,22,0.92)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(255,255,255,0.07)',
      }}>
        <button
          onClick={handleClose}
          style={{
            display: 'flex', alignItems: 'center', gap: 6,
            background: 'rgba(255,255,255,0.05)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: '8px',
            color: 'rgba(255,255,255,0.7)',
            fontSize: '13px', fontWeight: 600,
            padding: '6px 14px', cursor: 'pointer',
            transition: 'all 0.2s',
          }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
          onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.05)'}
        >
          ← বন্ধ করুন
        </button>
        <div style={{ fontSize: '15px', fontWeight: 700, color: 'var(--t1, #f0f0f5)' }}>
          পেমেন্ট শর্তাবলী
        </div>
        <div style={{ flex: 1 }} />
        {/* bKash logo pill */}
        <div style={{
          background: '#E2136E',
          borderRadius: '6px', padding: '4px 12px',
          fontSize: '12px', fontWeight: 800, color: '#fff',
          letterSpacing: '0.03em',
        }}>
          bKash
        </div>
      </div>

      {/* Content */}
      <div style={{ maxWidth: '760px', margin: '0 auto', padding: '32px 24px 60px' }}>

        {/* Title card */}
        <div style={{
          background: 'linear-gradient(135deg, rgba(226,19,110,0.15), rgba(226,19,110,0.05))',
          border: '1px solid rgba(226,19,110,0.3)',
          borderRadius: '14px',
          padding: '24px 28px',
          marginBottom: '28px',
        }}>
          <div style={{ fontSize: '22px', fontWeight: 800, color: '#E2136E', marginBottom: '8px' }}>
            aifield.art -এর পেমেন্ট টার্মস এবং কন্ডিশন
          </div>
          <div style={{ fontSize: '14px', color: 'rgba(255,255,255,0.55)', lineHeight: 1.6 }}>
            পেমেন্ট করার মাধ্যমে, আপনি নিচের শর্তাবলীতে সম্মত হচ্ছেন।
          </div>
        </div>

        {/* Sections */}
        {[
          {
            num: '১',
            title: 'পেমেন্টের মাধ্যম',
            text: 'বর্তমানে আমরা শুধুমাত্র বিকাশ সেন্ড মানি (bKash Send Money)-এর মাধ্যমে পেমেন্ট গ্রহণ করছি। অনুগ্রহ করে নিশ্চিত করুন যে আপনি আপনার নির্বাচিত প্ল্যানের জন্য সঠিক পরিমাণ টাকা পাঠিয়েছেন।',
          },
          {
            num: '২',
            title: 'প্রসেসিংয়ের সময় এবং ডেলিভারি',
            text: 'সফলভাবে টাকা পাঠানোর পর, আমাদের সিস্টেমে পেমেন্ট প্রসেস হতে এবং আপনার অ্যাকাউন্টে নির্বাচিত প্ল্যান ও ক্রেডিট যুক্ত হতে সর্বোচ্চ ১০ মিনিট সময় লাগতে পারে। প্রসেস সম্পন্ন হওয়ার সাথে সাথেই আপনি একটি কনফার্মেশন ইমেইল পাবেন।',
          },
          {
            num: '৩',
            title: 'ক্রেডিট বা প্ল্যান না পেলে করণীয়',
            paragraphs: [
              'সফলভাবে বিকাশ করার পর যদি ১০ মিনিট পার হয়ে যায় এবং আপনি আপনার প্ল্যান, ক্রেডিট বা কোনো কনফার্মেশন ইমেইল না পান, তবে অনুগ্রহ করে আমাদের সাপোর্ট টিমের সাথে যোগাযোগ করুন।',
              'কীভাবে জানাবেন: আমাদের সাপোর্ট ইমেইলে একটি মেইল করুন।',
              'প্রয়োজনীয় তথ্য: ইমেইলে অবশ্যই আপনার বিকাশ নম্বরটি (যে নম্বর থেকে টাকা পাঠিয়েছেন) এবং সঠিক ট্রানজেকশন আইডি (TrxID) উল্লেখ করতে হবে, যাতে আমরা বিষয়টি যাচাই করে দ্রুত সমাধান করতে পারি।',
            ],
          },
          {
            num: '৪',
            title: 'ক্রেডিট পলিসি ও মেয়াদ (Credit Rules & Expiry)',
            paragraphs: [
              'মান্থলি (Monthly) প্ল্যান: আপনি প্রতি মাসে একটি নির্দিষ্ট পরিমাণ ক্রেডিট পাবেন। এই ক্রেডিটগুলোর মেয়াদ আপনার বিলিং মাসের শেষ দিন পর্যন্ত থাকবে। মাস শেষে অব্যবহৃত ক্রেডিট বাতিল (Expire) হয়ে যাবে এবং নতুন মাসের জন্য নতুন ক্রেডিট যুক্ত হবে। কোনো ক্রেডিট পরবর্তী মাসে যোগ (Rollover) হবে না।',
              'ইয়ারলি (Yearly) প্ল্যান: ইয়ারলি প্ল্যানেও ক্রেডিটগুলো একবারে না দিয়ে প্রতি মাসে (মান্থলি প্ল্যানের মতো) দেওয়া হবে। প্রতি মাসের শেষে অব্যবহৃত ক্রেডিট বাতিল হয়ে যাবে এবং নতুন মাসের ক্রেডিট যুক্ত হবে।',
              'অ্যাড-অন বা এক্সট্রা ক্রেডিট (Add-on Credits): প্ল্যানের বাইরে কেনা এক্সট্রা ক্রেডিটগুলো কেনার দিন থেকে ঠিক ২ মাস (৬০ দিন) পর্যন্ত ব্যবহার করা যাবে। এগুলো প্ল্যানের বিলিং সাইকেলের সাথে রিসেট বা বাতিল হবে না।',
              'ব্যবহারের নিয়ম: জেনারেশনের সময় সবসময় আগে আপনার সাবস্ক্রিপশন (মান্থলি/ইয়ারলি) ক্রেডিট ব্যবহার করা হবে। সাবস্ক্রিপশন ক্রেডিট শেষ হয়ে গেলে তবেই আপনার কেনা অ্যাড-অন ক্রেডিট ব্যবহার করা শুরু হবে।',
            ],
          },
          {
            num: '৫',
            title: 'ভুয়া পেমেন্ট এবং অ্যাকাউন্ট ব্যান',
            text: 'আমরা প্রতিটি ট্রানজেকশন খুব নিবিড়ভাবে মনিটর করি। ভুয়া বা ফেক পেমেন্টের প্রমাণ দেওয়া, ভুল ট্রানজেকশন আইডি (TrxID) সাবমিট করা বা পেমেন্ট সিস্টেমে কোনো ধরনের কারচুপি করার চেষ্টা করা কঠোরভাবে নিষিদ্ধ। কোনো অ্যাকাউন্ট থেকে ফেক পেমেন্ট বা মিথ্যা তথ্য সাবমিট করা হলে, কোনো রকম পূর্ব সতর্কবার্তা ছাড়াই সেই আইডি স্থায়ীভাবে ব্যান (Ban) করা হবে।',
            warning: true,
          },
          {
            num: '৬',
            title: 'নন-রিফান্ডেবল পলিসি',
            text: 'পেমেন্ট করার পর তা সম্পূর্ণভাবে অফেরতযোগ্য (Non-refundable)। একবার ট্রানজেকশন বা লেনদেন সম্পন্ন হয়ে গেলে, আমরা কোনো অবস্থাতেই টাকা ফেরত দিতে বা অর্ডার বাতিল করতে পারব স্বাধীনতা রাখি। তাই পেমেন্ট করার আগে অনুগ্রহ করে নিশ্চিত হয়ে নিন যে আপনি সঠিক প্ল্যানটি বেছে নিয়েছেন এবং এটি কিনতে আপনি সম্পূর্ণ আগ্রহী।',
            warning: true,
          },
        ].map((section) => (
          <div key={section.num} style={{
            background: 'rgba(255,255,255,0.03)',
            border: '1px solid rgba(255,255,255,0.07)',
            borderRadius: '12px',
            padding: '20px 24px',
            marginBottom: '16px',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: '10px' }}>
              <div style={{
                width: 28, height: 28,
                borderRadius: '8px',
                background: 'rgba(226,19,110,0.15)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '13px', fontWeight: 800,
                color: '#E2136E',
                flexShrink: 0,
              }}>
                {section.num}
              </div>
              <div style={{ fontSize: '15px', fontWeight: 700, color: 'rgba(255,255,255,0.9)' }}>
                {section.title}
              </div>
            </div>
            {section.paragraphs
              ? section.paragraphs.map((p, i) => (
                  <p key={i} style={{ fontSize: '13.5px', color: 'rgba(255,255,255,0.6)', lineHeight: '1.75', marginBottom: i < section.paragraphs.length - 1 ? '12px' : 0 }}>
                    <span style={{ color: '#E2136E', fontWeight: 700, marginRight: '4px' }}>•</span> {p}
                  </p>
                ))
              : <p style={{ fontSize: '13.5px', color: 'rgba(255,255,255,0.6)', lineHeight: '1.75', margin: 0 }}>{section.text}</p>
            }
          </div>
        ))}

        {/* Footer */}
        <div style={{ textAlign: 'center', marginTop: '32px', fontSize: '12px', color: 'rgba(255,255,255,0.3)' }}>
          © {new Date().getFullYear()} aifield.art · সকল অধিকার সংরক্ষিত
        </div>
      </div>
    </div>
  );
}
